import { __read, __spread } from "tslib";
import { KEEN_VALUE } from '../../constants';
export var transformNominal = function (_a) {
    var result = _a.result;
    var data = [];
    var keys = new Set();
    keys.add(KEEN_VALUE);
    result.forEach(function (nominalValue) {
        var _a;
        data.push((_a = {},
            _a[KEEN_VALUE] = nominalValue,
            _a));
    });
    return {
        data: data,
        keys: __spread(keys),
    };
};
